const ptBR = {
  'nav.home': 'Início',
  'nav.features': 'Benefícios',
  'nav.services': 'Serviços',
  'nav.process': 'Processo',
  'nav.faq': 'FAQ',
  'buttons.contact': 'Fale Conosco',

  'hero.badge': 'Parceiros de Desenvolvimento',
  'hero.title.prefix': 'Potencialize seu negócio com',
  'hero.title.highlight': 'soluções digitais sob medida',
  'hero.subtext': 'Desenvolvemos produtos e aplicativos com ciclos ágeis, transparência e foco em resultados. Da descoberta à publicação, cuidamos de cada detalhe técnico.',
  'hero.bullets.process': 'Ciclos ágeis',
  'hero.bullets.deliveries': 'Entregas frequentes',
  'hero.bullets.security': 'Qualidade e segurança',
  'hero.cta.primary': 'Falar com Especialista',

  'features.heading': 'Por que escolher a Gruty?',
  'features.description': 'Processos ágeis, parceria transparente e soluções sob medida orientadas a resultados.',
  'features.items.systems.title': 'Sob medida',
  'features.items.systems.desc': 'Desenvolvimento personalizado para objetivos e contexto do seu negócio.',
  'features.items.integrations.title': 'Agilidade contínua',
  'features.items.integrations.desc': 'Ciclos curtos com entregas contínuas e previsíveis.',
  'features.items.backups.title': 'Transparência & Parceria',
  'features.items.backups.desc': 'Alinhamento constante, comunicação clara e acompanhamento do progresso.',
  'features.items.delivery.title': 'Foco em Resultados',
  'features.items.delivery.desc': 'Métricas e impacto como direção de cada entrega.',
  'features.items.observability.title': 'Qualidade & Segurança',
  'features.items.observability.desc': 'Boas práticas, testes e observabilidade desde o início.',
  'features.items.payments.title': 'Publicação & Escala',
  'features.items.payments.desc': 'DevOps, lojas e infraestrutura para crescer com confiança.',

  'services.heading': 'Serviços',
  'services.description': 'Do pré-projeto à publicação, cobrimos o ciclo completo de produto digital.',
  'services.items.web.title': 'Desenvolvimento Web',
  'services.items.web.desc': 'Websites e aplicações modernas, responsivas e orientadas a conversão.',
  'services.items.mobile.title': 'Aplicativos Mobile',
  'services.items.mobile.desc': 'Apps nativos e híbridos para iOS e Android com performance excepcional.',
  'services.items.backend.title': 'Integrações & APIs',
  'services.items.backend.desc': 'Integrações confiáveis com ERPs, CRMs, gateways e serviços externos.',
  'services.items.consulting.title': 'Design UX/UI',
  'services.items.consulting.desc': 'Experiências intuitivas e cativantes com foco em usabilidade.',
  'services.items.preproject.title': 'Pré‑projeto',
  'services.items.preproject.desc': 'Objetivos, escopo e requisitos bem definidos para iniciar com clareza.',
  'services.items.devops.title': 'DevOps & Publicação',
  'services.items.devops.desc': 'Pipeline, lojas e infraestrutura para lançar e escalar com segurança.',

  'cta.heading': 'Pronto para acelerar seu produto?',
  'cta.description': 'Vamos construir seu app com ciclos ágeis, qualidade e foco em resultados.',
  'cta.primary': 'Falar com Especialista',
  'cta.secondary': 'Ver Casos de Sucesso',

  'footer.description.line1': 'Construímos soluções digitais sob medida com ciclos ágeis.',
  'footer.description.line2': 'Excelência técnica, parceria e foco em resultados.',
  'footer.copyright': '© 2024 Gruty Software. Todos os direitos reservados.',

  'process.heading': 'Nosso Processo',
  'process.description': 'Etapas claras, entregas frequentes e alinhamento contínuo do início à publicação.',
  'process.steps.1.title': 'Descoberta',
  'process.steps.1.desc': 'Entendimento do contexto, objetivos e desafios do negócio.',
  'process.steps.2.title': 'Pré‑projeto',
  'process.steps.2.desc': 'Escopo, requisitos e metas definidos com clareza.',
  'process.steps.3.title': 'Design UX/UI',
  'process.steps.3.desc': 'Wireframes e interfaces focadas na usabilidade.',
  'process.steps.4.title': 'Desenvolvimento',
  'process.steps.4.desc': 'Implementação iterativa com ciclos ágeis.',
  'process.steps.5.title': 'Qualidade (QA)',
  'process.steps.5.desc': 'Testes, correções e observabilidade ativa.',
  'process.steps.6.title': 'Publicação',
  'process.steps.6.desc': 'Entrega, lojas e infraestrutura pronta para escala.',
  'process.steps.7.title': 'Evolução contínua',
  'process.steps.7.desc': 'Melhorias guiadas por métricas e feedback.',

  'faq.heading': 'Perguntas Frequentes',
  'faq.description': 'Tire suas dúvidas sobre nossos serviços e processos.',
  'faq.items.1.title': 'Como funciona o ciclo de entregas?',
  'faq.items.1.content': 'Trabalhamos com sprints de 2 semanas, demos ao cliente, atualizações semanais por escrito e acesso ao board de tarefas em tempo real.',
  'faq.items.2.title': 'Vocês oferecem suporte após a publicação?',
  'faq.items.2.content': 'Sim. Oferecemos pacotes de suporte mensal com SLA definido, monitoramento 24/7 e roadmap de evolução guiado por métricas.',
  'faq.items.3.title': 'É possível integrar com outros sistemas?',
  'faq.items.3.content': 'Sim. Integramos com APIs, ERPs, CRMs, gateways de pagamento e serviços externos.',
  'faq.items.4.title': 'Como vocês tratam segurança e qualidade?',
  'faq.items.4.content': 'Aplicamos boas práticas, testes e monitoramento desde o início do projeto.',
  'faq.items.5.title': 'Qual é o prazo médio de um projeto?',
  'faq.items.5.content': 'Projetos simples: 4-8 semanas. Sistemas complexos: 3-6 meses. Todo projeto começa com um pré-projeto de 1 semana para definir o escopo exato.',
  'faq.items.6.title': 'Vocês trabalham com projetos internacionais?',
  'faq.items.6.content': 'Sim. Atendemos Brasil e exterior, com comunicação em português e inglês.',

  'budget.projectDescription': 'Descreva seu projeto (opcional)',
  'budget.projectDescriptionPlaceholder': 'Conte um pouco sobre o que você precisa desenvolver...',
};

export default ptBR;
